import script from "./Template2.vue?vue&type=script&setup=true&lang=js"
export * from "./Template2.vue?vue&type=script&setup=true&lang=js"

import "./Template2.vue?vue&type=style&index=0&id=21c9ff4d&scoped=true&lang=less"
import "./Template2.vue?vue&type=style&index=1&id=21c9ff4d&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_typescript@4.9.5__webpack@5.112.2_2b87b21da4aed600185acfcb8e880229/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c9ff4d"]])

export default __exports__